import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useUserSubscription } from './useSubscription';
import useAuthStore from '../store/authStore';
import { subscriptionRefreshManager } from '../utils/subscriptionRefresh';

export const useSubscriptionCheck = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuthStore();
  const { subscriptionData, isLoading, refetchSubscription } = useUserSubscription();

  // Extract subscription status from the new API response structure
  const hasActiveSubscription = subscriptionData?.subscription?.isActive || false;

  // Listen for global subscription refresh events
  useEffect(() => {
    const unsubscribe = subscriptionRefreshManager.subscribe(() => {
      // Refetch subscription data when global refresh is triggered
      refetchSubscription();
    });

    return unsubscribe;
  }, [refetchSubscription]);

  console.log('Subscription Check Debug:', {
    subscriptionData,
    isLoading,
    hasActiveSubscription,
    isAuthenticated,
    user: user?.id
  });

  const checkSubscriptionBeforePlay = (isPaid = false) => {
    console.log('Checking subscription before play:', {
      isAuthenticated,
      isLoading,
      hasActiveSubscription,
      subscriptionData,
      isPaid
    });

    // If user is not authenticated, redirect to signin
    if (!isAuthenticated) {
      navigate('/signin');
      return false;
    }

    // If still loading, allow the action (will be checked again)
    if (isLoading) {
      console.log('Still loading subscription data, allowing play');
      return true;
    }

    // Only check subscription for paid content
    if (isPaid && !hasActiveSubscription) {
      console.log('No active subscription found for paid content, redirecting to plans');
      toast.info('Premium subscription required to access this content');
      navigate('/subscription-plans');
      return false;
    }

    console.log('Subscription check passed, allowing play');
    return true;
  };

  return {
    checkSubscriptionBeforePlay,
    hasActiveSubscription,
    isLoading,
    isAuthenticated
  };
}; 